import { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import lottie from "lottie-web";

const RadarAnimation = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return undefined;

    const animation = lottie.loadAnimation({
      container: containerRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: `${process.env.PUBLIC_URL}/assets/raw/radar.json`,
    });

    return () => animation.destroy();
  }, []);

  return (
    <Box
      ref={containerRef}
      sx={{
        width: 220,
        height: 220,
        maxWidth: "70vw",
        maxHeight: "70vw",
      }}
    />
  );
};

export default RadarAnimation;
